import { useState, useEffect } from "react";
import {read_cookie} from "sfcookies";
import { hostUrl, UseUrlManagerCleanUrl } from "../../../utils/url-manager";
import {downloadBase64Pdf} from "../../../utils/download-pdf";

type UseInvoicePreviewDataProps = {
    loadingInvoiceData: boolean,
    invoiceData: any,

}

export const useInvoicePreviewData: (id: string) => UseInvoicePreviewDataProps = (id: string): UseInvoicePreviewDataProps => {
    const [loadingInvoiceData, setLoadingInvoiceData] = useState<boolean>(false);
    const [invoiceData, setInvoiceData] = useState<any>();
    const token: string = read_cookie('auth');
    const request: Request = new Request(UseUrlManagerCleanUrl({ url: hostUrl + 'hq/customer/account/invoice/preview' }), {
        method: 'POST',
        body: JSON.stringify({ id: id }),
        headers: new Headers({
            'Content-Type' : 'application/json',
            'token': token
        })
    });
    if (id !== undefined) {
        fetch(request)
            .then( (response: Response): Promise<any> => {
                return response.json()
            })
            .then( (data: any): void => {
                setLoadingInvoiceData(false)
                if (data && data.status === 'success' && invoiceData === undefined) {
                    setInvoiceData(data.data);
                }
            })
            .catch( (error: Error): Promise<any> => {
                console.log(error);
                return Promise.reject();
            });
    }

    return { loadingInvoiceData, invoiceData }

}

type UseInvoiceGeneratorProps = {
    loadingInvoice: boolean,
    generateInvoicePDF: () => void
}

export const useInvoiceGenerator: (id: string) => UseInvoiceGeneratorProps  = (id: string): UseInvoiceGeneratorProps => {
    const [loadingInvoice, setLoadingInvoice] = useState(false);

    function generateInvoicePDF(): void {
        setLoadingInvoice(true);
        const token: string = read_cookie('auth');
        const request: Request = new Request(UseUrlManagerCleanUrl({ url: hostUrl + 'hq/customer/account/invoice/generator' }), {
            method: 'POST',
            body: JSON.stringify({ id: id }),
            headers: new Headers({
                'Content-Type' : 'application/json',
                'token': token
            })
        });
        if (id !== undefined) {
            fetch(request)
                .then( (response: Response): Promise<any> => {
                    return response.json()
                })
                .then( (data: any): void => {
                    setLoadingInvoice(false)
                    if (data && data.status === 'success' && data.pdf !== undefined) {
                        downloadBase64Pdf(data.pdf, data?.filename);
                    }
                })
                .catch( (error: Error): Promise<any> => {
                    console.log(error);
                    return Promise.reject();
                });
        }
    }


    return { loadingInvoice, generateInvoicePDF }

}